<template>
  <div class="schedule-status">
    <i class="dot" :style="'background-color:' + color[innerText]"></i>
    {{ status }}
  </div>
</template>

<script>
export default {
  name: 'ScheduleStatus',
  props: { innerText: Number },
  data() {
    return {
      color: ['#606266', '#8EDF5D', '#FA7589', '#E6A23C'],
    }
  },
  computed: {
    status() {
      const statusTable = {
        0: '待上课',
        1: '已上课',
        2: '缺课',
        3: '正在上课',
      }
      return statusTable[this.innerText]
    },
  },
}
</script>

<style lang='scss' scoped>
.schedule-status {
  .dot {
    display: inline-block;
    width: 12px;
    height: 12px;
    background-color: #8edf5d;
    border-radius: 50%;
  }
}
</style>